<template>
  <div class="card-image">
    <figure v-if="imageURL" class="image is-3by1">
      <img :src="imageURL" />
    </figure>

    <div v-else class="image is-3by1 empty-image">
      <p class="no-image">{{ $t("dashboard.noImage") }}</p>
    </div>
  </div>
</template>

<script>
export default {
  props: ["imageURL"]
};
</script>

<style scoped>
.empty-image {
  border: 1px solid gray;
  background-color: aliceblue;
}
.no-image {
  position: absolute;
  top: 1rem;
  left: 1rem;
}
</style>
